export var WorkflowStateEnum;
(function (WorkflowStateEnum) {
    WorkflowStateEnum[WorkflowStateEnum["Pending"] = 1] = "Pending";
    WorkflowStateEnum[WorkflowStateEnum["InProgress"] = 2] = "InProgress";
    WorkflowStateEnum[WorkflowStateEnum["Completed"] = 3] = "Completed";
    WorkflowStateEnum[WorkflowStateEnum["Cancelled"] = 4] = "Cancelled";
})(WorkflowStateEnum || (WorkflowStateEnum = {}));
